import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { CallableFunction } from '../../resources/app-firebase';
import { CommonIdFindPlaylistOriginalProblemIdsResponse } from 'src/app/models/common-id/common-id-playlist-original-problem';

@Injectable({
  providedIn: 'root'
})
export class CommonIdFindPlaylistOriginalProblemsService {
  constructor(private aff: AngularFireFunctions) {}

  commonIdFindPlaylistOriginalProblemIds(): Observable<CommonIdFindPlaylistOriginalProblemIdsResponse[]> {
    const callable = this.aff.httpsCallable(CallableFunction.COMMON_ID_FIND_PLAY_LISTORIGINAL_PROBLEM_IDS);
    return callable({});
  }
}
